import React from 'react'
import '../../styles/about-company.sass'
import file from '../../img/File icon.svg'
import { files } from '../files'

const AboutCompanyComponent = () => (
  <div className='about-company'>
    Компания Оверком – команда разработчиков комплексного программного обеспечения процессинговых центров, систем лояльности, интеграционных услуг для топливных компаний. Эксперты в разработке решений с использованием технологий компьютерного зрения и машинного обучения.
    <div className='files' onClick={() => {
      window.open(`${files.about}`, '_blank')
    }}>
      <img src={file} alt='file-icon' /><p>Сведения о внесении продуктов в реестр ПО</p>
    </div>
  </div>
)

export default AboutCompanyComponent